(function($){

    var $controller  = {

        selector: '.form-with-reset [type="reset"]',

        init: function() {
            this.listen();
        },
        
        listen: function() {
            
            setTimeout(function() {

                $($controller.selector).click(function($evt) {
                    window.location.href = $(this).closest('form').prop('action');
                });

            });

        }

    };

    $controller.init();

})(jQuery);


// WEBPACK FOOTER //
// ./tbo/js/listen/form/reset.js